<script>
import constants from "@/constants";
import { Doughnut as DoughnutInstance } from "vue-chartjs";

export default {
  name: "DoughnutChart",
  extends: DoughnutInstance,
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          labels: [],
          dataset: []
        }
      }
    },
    bgColors: {
      type: Array,
      default: () => constants.doughnutChartBgColors,
    },
    labelFormatter: {
      type: Function,
      default: null
    },
    tooltipFormatter: {
      type: Function,
      default: null
    }
  },
  computed: {
    chartData() {
      const { labels, dataset } = this.data;
      return {
        labels,
        datasets: [
          {
            label: dataset[0].label,
            data: dataset[0].data,
            backgroundColor: this.bgColors
          }
        ]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          position: "top"
        },
        layout: {
          padding: {
            top: 40
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const value = dataset.data[tooltipItem.index];
              const label = data.labels[tooltipItem.index] || '';
              if(this.labelFormatter){
                return this.tooltipFormatter(value, label);
              }
              return `${label}: ${value}`;
            }
          }
        },
        plugins: {
          datalabels: {
            color: '#fff',
            textAlign: "center",
            font: {
              weight: "bold",
              color: '#fff',
              size: 14
            },
            formatter: (value) => {
              if (this.labelFormatter) {
                return this.labelFormatter(value);
              }
              return this.$numeral(value).format('0,0')
            }
          }
        }
      };
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  watch: {
    chartData() {
      this.renderChart(this.chartData, this.chartOptions);
      // this.$data._chart.update();
    }
  }
};
</script>

<style lang="scss" scoped></style>
